export enum QuestionFormActions {
  Add = 'ADD',
  Duplicate = 'DUPLICATE',
  Delete = 'DELETE',
}

export interface ScorecardCreatorProps {
  scorecardId?: string;
}

export enum FormSection {
  Basic = 'BASIC',
  Questions = 'QUESTIONS',
}
